import {
  Grid,
  Box,
  styled,
  Typography,
  Button,
  IconButton,
} from "@mui/material";
import LocationCard from "../../components/MyActivityComponents/Cards/LocationCard";

const CustomPaper = styled(Box)({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "0px 10px 0px 10px",
  gap: "8px",
  width: "100%",
  height: "94px",
  background: "#FFFFFF",
  border: "1px solid #E1E1E6",
  borderRadius: "4px",
});

const Title = styled(Typography)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "20px",
  letterSpacing: "0.015em",
  color: "#1A1824",
}));

const LightTitle = styled(Typography)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "160%",
  letterSpacing: "0.015em",
  color: "#9EA3AE",
}));

const FlexBox = styled(Box)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

const SaveAddressSection = () => {
  return (
    <Box style={{width:"100%", padding:"10px"}}>
      <Grid container spacing={2}>
        <Grid item sm={2} xs={12}>
          <Title style={{ fontSize: "24px" }} mb={3}>
            Saved Address
          </Title>
        </Grid>
        <Grid item sm={10} xs={12} style={{ textAlign: "end" }}>
          <Button variant="contained" style={{ textTransform: "none" }}>
            <i className="fa fa-plus" style={{ marginRight: "10px" }}></i>Add
            new address
          </Button>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item sm={12} xs={12}>
          <Box style={{ width: "99%" }}>
            <LocationCard
              title={"My Home"}
              subTitle={"George Street. St."}
              hasDefaultButton
              onDefaultClick={() => {
                console.log("default clicked");
              }}
              imageSrc={require("../../assets/Vectorhome.png")}
            />

            <LocationCard
              title={"Office"}
              subTitle={"George Street. St."}
              hasResetButton
              onResetClick={() => {
                console.log("reset clicked");
              }}
              imageSrc={require("../../assets/Vectorbuilding.png")}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

const CustomPaperContainer = ({
  title,
  subTitle,
  hasDefaultButton = false,
  hasResetButton = false,
  onDefaultClick,
  onResetClick,
  onEdit,
  onDelete,
  imageSrc,
}) => {
  return (
    <CustomPaper mt={2}>
      <Box>
        <Box style={{ display: "flex" }}>
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: "10px",
            }}
          >
            <img src={imageSrc} />
          </Box>
          <Box>
            <Box display="flex">
              <Title>{title}</Title>
              {hasDefaultButton && (
                <Button
                  variant="text"
                  style={{ textTransform: "none" }}
                  onClick={onDefaultClick}
                >
                  Default Location
                </Button>
              )}
            </Box>
            <LightTitle>{subTitle}</LightTitle>
            {hasResetButton && (
              <Button
                onClick={onResetClick}
                variant="text"
                style={{ textTransform: "none", textDecoration: "underline" }}
              >
                Set as default location
              </Button>
            )}
          </Box>
        </Box>
      </Box>
      <Box>
        <IconButton
          color="primary"
          aria-label="upload picture"
          component="label"
          onClick={onDelete}
        >
          <i
            class="fas fa-trash-alt"
            style={{ color: "#9EA3AE", fontSize: "16px" }}
          ></i>
        </IconButton>
        <IconButton
          color="primary"
          aria-label="upload picture"
          component="label"
          onClick={onEdit}
        >
          <i
            class="fas fa-pen"
            style={{ color: "#9EA3AE", fontSize: "16px" }}
          ></i>
        </IconButton>
      </Box>
    </CustomPaper>
  );
};
export default SaveAddressSection;
